// Si la URL no trae UTM, se usan estos valores (no usar "llamada" ni medios de contacto como UTM)
export const DEFAULT_UTM_SOURCE = "directo";
export const DEFAULT_UTM_MEDIUM = "landing_campaña";

// Configuración de números de WhatsApp por UTM parameters
export const whatsappConfig = {
  // Número por defecto (original)
  default: {
    number: "+543516825130",
    message: "Hola Automont!",
  },
  // BOT IA de Hyundai - para Santa Fe
  hyundaiSantaFeBot: {
    number: process.env.REACT_APP_HYUNDAI_SANTAFE_BOT_WHATSAPP || "5493517385093",
    message: "Quiero encargar la nueva Hyundai Santa Fé",
  },
};

// Función para obtener la URL de WhatsApp según los UTM parameters
export const getWhatsAppUrl = (utmParams = {}) => {
  const { utm_source, utm_medium, utm_campaign } = utmParams;

  // Si es TikTok con campaña específica
  if (utm_source === "tiktok" && utm_campaign) {
    const tiktokConfig = whatsappConfig.tiktok;
    const campaignConfig = tiktokConfig.campaigns[utm_campaign];

    if (campaignConfig) {
      const encodedMessage = encodeURIComponent(campaignConfig.message);
      return `https://api.whatsapp.com/send?phone=${campaignConfig.number}&text=${encodedMessage}`;
    }
  }

  // Si es TikTok general
  if (utm_source === "tiktok") {
    const tiktokConfig = whatsappConfig.tiktok;
    const encodedMessage = encodeURIComponent(tiktokConfig.message);
    return `https://api.whatsapp.com/send?phone=${tiktokConfig.number}&text=${encodedMessage}`;
  }

  // Si es otro source configurado
  if (utm_source && whatsappConfig[utm_source]) {
    const config = whatsappConfig[utm_source];
    const encodedMessage = encodeURIComponent(config.message);
    return `https://api.whatsapp.com/send?phone=${config.number}&text=${encodedMessage}`;
  }

  // URL por defecto
  const defaultConfig = whatsappConfig.default;
  const encodedMessage = encodeURIComponent(defaultConfig.message);
  return `https://api.whatsapp.com/send?phone=${defaultConfig.number}&text=${encodedMessage}`;
};

// Función para extraer UTM parameters de la URL actual
// utm_source / utm_medium: SOLO la URL o valores por defecto (directo / landing_campaña).
// No usar sessionStorage para source/medium: si no, queda pegado un origen viejo (ej. medios tradicionales).
export const getUtmParams = () => {
  const query = new URLSearchParams(window.location.search);
  const fromUrlSource = query.get("utm_source");
  const fromUrlMedium = query.get("utm_medium");
  return {
    utm_source: fromUrlSource || DEFAULT_UTM_SOURCE,
    utm_medium: fromUrlMedium || DEFAULT_UTM_MEDIUM,
    utm_campaign: query.get("utm_campaign") || sessionStorage.getItem("utm_campaign"),
    utm_term: query.get("utm_term") || sessionStorage.getItem("utm_term"),
  };
};

// Función para guardar UTM parameters en sessionStorage (campaña/term); limpia source/medium si no vienen en la URL
export const saveUtmParams = () => {
  const query = new URLSearchParams(window.location.search);
  if (query.get("utm_source")) {
    sessionStorage.setItem("utm_source", query.get("utm_source"));
  } else {
    sessionStorage.removeItem("utm_source");
  }
  if (query.get("utm_medium")) {
    sessionStorage.setItem("utm_medium", query.get("utm_medium"));
  } else {
    sessionStorage.removeItem("utm_medium");
  }
  if (query.get("utm_campaign")) {
    sessionStorage.setItem("utm_campaign", query.get("utm_campaign"));
  }
  if (query.get("utm_term")) {
    sessionStorage.setItem("utm_term", query.get("utm_term"));
  }
};

